// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2saqz","paramInput":"JobSimulator_paramInput__jdb4E","input":"JobSimulator_input__77YG2"};